import { Unauthorized, RequestTimeout, DomainError as StandardDomainError } from '@ad-scripts/application/lib/error';
import { IsNotEmpty, IsNumber, IsString } from 'class-validator';
import { logout } from 'src/actions/auth/authSlice';
import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError } from 'src/actions/toast';
import { translateErrors } from 'src/adapters/validateType';
import { LookupResults } from './lookupDebuggerBasicResource';

export class LookupDebuggerDetailed {
  integrationId: string;
  request: DetailedRequest;
  response: LookupDebugResponse;
  validationErrors: [];
}

export class DetailedRequest {
  @IsString()
  @IsNotEmpty()
  url: string;
  payload: {
    lookupLevel: string;
    uniqueMatchRequired: boolean;
    query: { [k: string]: any };
  };
}

export class LookupDebugResponse {
  adapterError: any;
  @IsNumber()
  @IsNotEmpty()
  statusCode: string;
  rawResponse: string;
  payload: {
    results: LookupResults[];
  };
}

export const lookupDebuggerDetailedResource = createDocumentResource<LookupDebuggerDetailed>({
  name: 'debugDetailedLookup',
  endpoint: '/v1/orgs/:orgId/customer-extensions/:customerId/integrations/:integrationId/debug-info',
  type: LookupDebuggerDetailed,
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchStarted(state) {
      state.loadingState = 'loading';
    },
    fetchSuccess(state, action) {
      state.loadingState = 'succeeded';
      state.value = action.payload;
    },
    fetchError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    fetchRequestError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    reset(state) {
      state.loadingState = 'unstarted';
      state.value = {};
      state.errors = [];
    },
    timeoutError(state) {
      state.loadingState = 'failed';
      state.errors = [{ code: 'timeout' }];
    },
  },
  initialValue: {},
});

const fetchDetailedDebugging: sharedTypes.AppThunk =
  (urlParams, payload) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(lookupDebuggerDetailedResource.actions.fetchStarted({}));
      const result = await gateways.detailedLookupDebugging.fetchDetailedDebugging(urlParams, payload);
      dispatch(lookupDebuggerDetailedResource.actions.fetchSuccess(result));
    } catch (err) {
      dispatch(toastError(`There was an error fetching debug data.`));
      if (err instanceof StandardDomainError) {
        dispatch(lookupDebuggerDetailedResource.actions.fetchError(translateErrors(err.errors)));
      } else if (err instanceof RequestTimeout) {
        dispatch(lookupDebuggerDetailedResource.actions.timeoutError({}));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(lookupDebuggerDetailedResource.actions.fetchRequestError(translateErrors((err as any).errors)));
      }
    }
  };

const unload: sharedTypes.AppThunk = () => dispatch => {
  dispatch(lookupDebuggerDetailedResource.actions.reset({}));
};

lookupDebuggerDetailedResource.effects.fetchDetailedDebugging = fetchDetailedDebugging;
lookupDebuggerDetailedResource.effects.unload = unload;

export default lookupDebuggerDetailedResource;
